<main class="main-container">
    <form [formGroup]="urbanPlannerInfoForm" (ngSubmit)="onSubmit()">
        <div class="content-padding">
            <div class="row paragraph mt-3">
                <div class="col-12 heading-2">
                    Step 1: Personal And Company Information
                </div>
            </div>
            <div class="row paragraph mt-4">
                <div class="col-10">
                    Which year did you graduate as a planner?
                </div>
                <div class="col-10">

                    <input class="default-input" data-required="true" id="graduationYear" type="number"
                        placeholder="Graduation Year" formControlName="graduationYear" [ngClass]="{
                'invalid-input':
                    urbanPlannerInfoForm.get('graduationYear').invalid &&
                    urbanPlannerInfoForm.get('graduationYear').touched,
                'valid-input':
                    urbanPlannerInfoForm.get('graduationYear').valid &&
                    urbanPlannerInfoForm.get('graduationYear').touched
            }" />
                    <small class="burnt-red" *ngIf="
                urbanPlannerInfoForm.get('graduationYear').invalid &&
                urbanPlannerInfoForm.get('graduationYear').touched
            ">
                        * Invalid graduation year.
                    </small>
                </div>
            </div>
            <div class="row paragraph mt-4">
                <div class="col-10">
                    From which institution did you graduate?
                </div>
                <div class="col-10">
                    <input class="default-input" data-required="true" id="graduationInstitution" type="text"
                        placeholder="Graduation Institution" maxlength="250" formControlName="graduationInstitution"
                        [ngClass]="{
                'invalid-input':
                    urbanPlannerInfoForm.get('graduationInstitution').invalid &&
                    urbanPlannerInfoForm.get('graduationInstitution').touched,
                'valid-input':
                    urbanPlannerInfoForm.get('graduationInstitution').valid &&
                    urbanPlannerInfoForm.get('graduationInstitution').touched
            }" /><small class="burnt-red" *ngIf="
                urbanPlannerInfoForm.get('graduationInstitution').invalid &&
                urbanPlannerInfoForm.get('graduationInstitution').touched
            "> * This field is required.
                    </small>
                </div>
            </div>
            <div class="row paragraph mt-4">
                <div class="col-10">
                    How many years of experience do you have in the field of land use management (statutory planning)
                    specifically?
                </div>
                <div class="col-10">
                    <input class="default-input" data-required="true" id="yearsOfExperience" type="number"
                        placeholder="Years Of Experience" formControlName="yearsOfExperience" [ngClass]="{
                'invalid-input':
                    urbanPlannerInfoForm.get('yearsOfExperience').invalid &&
                    urbanPlannerInfoForm.get('yearsOfExperience').touched,
                'valid-input':
                    urbanPlannerInfoForm.get('yearsOfExperience').valid &&
                    urbanPlannerInfoForm.get('yearsOfExperience').touched
            }" /><small class="burnt-red" *ngIf="
                urbanPlannerInfoForm.get('yearsOfExperience').invalid &&
                urbanPlannerInfoForm.get('yearsOfExperience').touched
            "> * Invalid years of experience.
                    </small>
                </div>
            </div>
            <div class="row paragraph mt-4">
                <div class="col-10">
                    Under which name does you/your company operate?
                </div>
                <div class="col-10">
                    <input class="default-input" data-required="true" id="companyName" type="text"
                        placeholder="Company Name" maxlength="250" formControlName="companyName" [ngClass]="{
                   'invalid-input':
                       urbanPlannerInfoForm.get('companyName').invalid &&
                       urbanPlannerInfoForm.get('companyName').touched,
                   'valid-input':
                       urbanPlannerInfoForm.get('companyName').valid &&
                       urbanPlannerInfoForm.get('companyName').touched
               }" />
                    <small class="burnt-red" *ngIf="
                urbanPlannerInfoForm.get('companyName').invalid &&
                urbanPlannerInfoForm.get('companyName').touched
             "> * Invalid company name.
                    </small>
                </div>
            </div>
            <div class="row paragraph mt-4">
                <div class="col-10">
                    Physical address from which you primarily operate?
                </div>
                <div class="col-10">
                    <input class="default-input" data-required="true" id="propertyAddress" type="text"
                        placeholder="Property Address" maxlength="250" formControlName="propertyAddress" [ngClass]="{
                   'invalid-input':
                       urbanPlannerInfoForm.get('propertyAddress').invalid &&
                       urbanPlannerInfoForm.get('propertyAddress').touched,
                   'valid-input':
                       urbanPlannerInfoForm.get('propertyAddress').valid &&
                       urbanPlannerInfoForm.get('propertyAddress').touched
               }" />
                    <small class="burnt-red" *ngIf="
            urbanPlannerInfoForm.get('propertyAddress').invalid &&
            urbanPlannerInfoForm.get('propertyAddress').touched
        ">
                        * Invalid property address.
                    </small>
                </div>
            </div>
        </div>
        <div class="content-padding">
            <div class="row paragraph mt-4">
                <div class="col-10">
                    If applicable - your company registration number?
                </div>
                <div class="col-10">
                    <input class="default-input" id="companyRegistrationNumber" type="text"
                        placeholder="Company Registration Number" maxlength="250"
                        formControlName="companyRegistrationNumber" [ngClass]="{
                   'invalid-input':
                       urbanPlannerInfoForm.get('companyRegistrationNumber').invalid &&
                       urbanPlannerInfoForm.get('companyRegistrationNumber').touched,
                   'valid-input':
                       urbanPlannerInfoForm.get('companyRegistrationNumber').valid &&
                       urbanPlannerInfoForm.get('companyRegistrationNumber').touched,
                   'neutral-input':
                       urbanPlannerInfoForm.get('companyRegistrationNumber').untouched
               }" />
                    <small class="burnt-red" *ngIf="
            urbanPlannerInfoForm.get('companyRegistrationNumber').invalid &&
            urbanPlannerInfoForm.get('companyRegistrationNumber').touched
        ">* Invalid company registration number.
                    </small>
                </div>
            </div>
            <div class="row paragraph mt-4">
                <div class="col-10">
                    If applicable - your company VAT number?
                </div>
                <div class="col-10">
                    <input class="default-input" id="companyVatNumber" type="text" placeholder="Company VAT Number"
                        maxlength="250" formControlName="companyVatNumber" [ngClass]="{
                   'invalid-input':
                       urbanPlannerInfoForm.get('companyVatNumber').invalid &&
                       urbanPlannerInfoForm.get('companyVatNumber').touched,
                   'valid-input':
                       urbanPlannerInfoForm.get('companyVatNumber').valid &&
                       urbanPlannerInfoForm.get('companyVatNumber').touched,
                   'neutral-input':
                       urbanPlannerInfoForm.get('companyVatNumber').untouched
               }" />
                    <small class="burnt-red" *ngIf="
            urbanPlannerInfoForm.get('companyVatNumber').invalid &&
            urbanPlannerInfoForm.get('companyVatNumber').touched
        ">
                        * Invalid VAT number.
                    </small>
                </div>
            </div>
            <div class="row paragraph mt-4">
                <div formArrayName="municipalCouncils">
                    <div class="bold mb-2">
                        At which municipal council(s) do you mostly submit planning applications?
                    </div>
                    <div *ngFor="let council of municipalCouncils; let i = index" class="mt-1">
                        <mat-checkbox [formControlName]="i">
                            {{ council.value === 'Other' && isOtherMunicipalCouncilChecked()
                            ? council.value + ' - Please specify'
                            : council.value }}
                        </mat-checkbox>
                    </div>
                </div>
                <div *ngIf="isOtherMunicipalCouncilChecked()" class="mt-2">
                    <input class="mat-input-section" id="otherMunicipalCouncil" maxlength="250"
                        formControlName="otherMunicipalCouncil" placeholder="Required if other is selected" type="text">
                </div>
            </div>
            <div class="row paragraph mt-4">
                <div formArrayName="landDevelopmentTypes">
                    <div class="bold mb-2">
                        Indicate any type of land development applications in which you have extensive experience and
                        knowledge:
                    </div>
                    <div *ngFor="let type of landDevelopmentTypes; let i = index" class="mt-1">
                        <mat-checkbox [formControlName]="i">
                            {{ type.value === 'Other' && isOtherLandDevelopmentTypeChecked()
                            ? type.value + ' - Please specify'
                            : type.value }}
                        </mat-checkbox>
                    </div>
                </div>
                <div *ngIf="isOtherLandDevelopmentTypeChecked()" class="mt-2">
                    <input class="mat-input-section" id="otherLandDevelopmentType" maxlength="250"
                        formControlName="otherLandDevelopmentType" placeholder="Required if other is selected"
                        type="text">
                </div>
            </div>
            <div class="row paragraph mt-4">
                <label class="bold mb-2">
                    Do you have proven experience in conducting feasibility/viability studies, calculating the maximum
                    projected ROI for developments projects?
                </label>
                <mat-radio-group formControlName="hasFeasibilityStudyExperience">
                    <mat-radio-button class="mt-1" [value]="true">Yes</mat-radio-button>
                    <mat-radio-button class="mt-1" [value]="false">No</mat-radio-button>
                </mat-radio-group>
            </div>
            <div *ngIf="hasFeasibilityStudyExperience">
                <div class="row paragraph mt-4">
                    <div formArrayName="developmentSpecialties">
                        <div class="bold mb-2">
                            <span class="burnt-red">|</span>
                            In which types of developments do you specialise to do feasibility/viability studies?
                        </div>
                        <div *ngFor="let specialty of developmentSpecialties; let i = index" class="mt-1">
                            <mat-checkbox [formControlName]="i">
                                {{ specialty.value === 'Other' && isOtherDevelopmentSpecialtyChecked()
                                ? specialty.value + ' - Please specify'
                                : specialty.value }}
                            </mat-checkbox>
                        </div>
                    </div>
                    <div *ngIf="isOtherDevelopmentSpecialtyChecked()" class="mt-2">
                        <input class="mat-input-section" id="otherDevelopmentSpecialty" maxlength="250"
                            formControlName="otherDevelopmentSpecialty" placeholder="Required if other is selected"
                            type="text">
                    </div>
                </div>
            </div>
            <div class="row paragraph mt-3">
                <div class="bold">
                    Details of a support staff member we may contact regarding <u>administrative</u> queries:
                </div>
            </div>
            <div class="row paragraph mt-3">
                <div class="col-3">
                    <label for="supportName">Name:</label>
                </div>
                <div class="col-7">
                    <input id="supportName" class="default-input" formControlName="supportName" type="text"
                        maxlength="250">
                </div>
            </div>
            <div class="row paragraph mt-3">
                <div class="col-3">
                    <label for="supportSurname">Surname:</label>
                </div>
                <div class="col-7">
                    <input id="supportSurname" class="default-input" formControlName="supportSurname" type="text"
                        maxlength="250">
                </div>
            </div>
            <div class="row paragraph mt-3">
                <div class="col-3">
                    <label for="supportPosition">Position:</label>
                </div>
                <div class="col-7">
                    <input id="supportPosition" class="default-input" formControlName="supportPosition" type="text"
                        maxlength="250">
                </div>
            </div>
            <div class="row paragraph mt-3">
                <div class="col-3">
                    <label for="supportLandLine">Landline:</label>
                </div>
                <div class="col-7">
                    <input id="supportLandLine" class="default-input" formControlName="supportLandLine" type="text"
                        [ngClass]="{'invalid-input':
                            urbanPlannerInfoForm.get('supportLandLine').invalid &&
                            urbanPlannerInfoForm.get('supportLandLine').touched}">
                    <small class="burnt-red" *ngIf="
                        urbanPlannerInfoForm.get('supportLandLine').invalid &&
                        urbanPlannerInfoForm.get('supportLandLine').touched">
                        * Landline must contain exactly 10 digits.
                    </small>
                </div>
            </div>
            <div class="row paragraph mt-3">
                <div class="col-3">
                    <label for="supportMobile">Mobile:</label>
                </div>
                <div class="col-7">
                    <input id="supportMobile" class="default-input" formControlName="supportMobile" type="text"
                        [ngClass]="{'invalid-input':
                            urbanPlannerInfoForm.get('supportMobile').invalid &&
                            urbanPlannerInfoForm.get('supportMobile').touched}">
                    <small class="burnt-red" *ngIf="
                        urbanPlannerInfoForm.get('supportMobile').invalid &&
                        urbanPlannerInfoForm.get('supportMobile').touched">
                        * Mobile number must contain exactly 10 digits.
                    </small>
                </div>
            </div>
            <div class="row paragraph mt-3">
                <div class="col-3">
                    <label for="supportEmail">Email:</label>
                </div>
                <div class="col-7">
                    <input id="supportEmail" class="default-input" formControlName="supportEmail" type="text" [ngClass]="{'invalid-input':
                            urbanPlannerInfoForm.get('supportEmail').invalid &&
                            urbanPlannerInfoForm.get('supportEmail').touched}">
                    <small class="burnt-red" *ngIf="
                        urbanPlannerInfoForm.get('supportEmail').invalid &&
                        urbanPlannerInfoForm.get('supportEmail').touched">
                        * Invalid email address.
                    </small>
                </div>
            </div>
        </div>
        <div class="row paragraph mt-5">
            <div class="text-center">
                <button class="button" type="submit" [disabled]="urbanPlannerInfoForm.invalid">SUBMIT</button>
            </div>
        </div>
    </form>
</main>